import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "fs-2 mr-3" }
const _hoisted_5 = {
  key: 0,
  class: "section-sport d-flex align-items-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 mx-3 text-black" }, null, -1)
const _hoisted_7 = { class: "me-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 mx-3 text-black" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "Nominal", -1)
const _hoisted_10 = {
  key: 0,
  class: "text-gray-700 fw-bold fs-6"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle text-info fs-4" })
], -1)
const _hoisted_12 = {
  class: "demo-rich-conent",
  style: {"display":"flex","gap":"16px","flex-direction":"column"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder mb-0" }, "Representante", -1)
const _hoisted_14 = { class: "fs-1x" }
const _hoisted_15 = { class: "list-unstyled" }
const _hoisted_16 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-telephone-fill me-2 fs-3" }, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope-at-fill me-2 fs-3" }, null, -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm-12 col-md-6 col-lg-3" }
const _hoisted_22 = { class: "sticky-lg-top" }
const _hoisted_23 = { class: "col-sm-12 col-md-6 col-lg-9" }
const _hoisted_24 = {
  key: 0,
  class: "d-flex justify-content-between flex-wrap"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people text-white me-2 fs-2" }, null, -1)
const _hoisted_26 = {
  key: 2,
  class: ""
}
const _hoisted_27 = { class: "d-flex align-items-center gap-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down fs-1x text-white" }, null, -1)
const _hoisted_29 = { key: 2 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person text-white me-2 fs-2 p-0" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-check text-white me-2 fs-2 p-0" }, null, -1)
const _hoisted_32 = {
  key: 0,
  class: "fa fa-cog fa-spin text-white me-2 fs-2"
}
const _hoisted_33 = {
  key: 1,
  class: "bi bi-cloud-arrow-down text-white fs-1 me-2"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill text-primary ms-3" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill text-primary ms-3" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "card card-custom border rounded-0",
  style: {"background-color":"#F6F0FF"}
}, null, -1)
const _hoisted_37 = { class: "card card-custom border-start border-end rounded-0" }
const _hoisted_38 = { class: "card-header flex-wrap px-3 rounded-0" }
const _hoisted_39 = { class: "card-title" }
const _hoisted_40 = { class: "card-toolbar" }
const _hoisted_41 = { class: "me-2 fw-bolder" }
const _hoisted_42 = {
  class: "",
  style: {"line-height":"1.25"}
}
const _hoisted_43 = { class: "fw-bolder" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = { class: "text-gray-600" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  class: "text-dark-50",
  style: {"line-height":"1.25"}
}
const _hoisted_48 = { class: "text-capitalize fw-bold" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = { class: "text-capitalize text-gray-600" }
const _hoisted_51 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_52 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_53 = {
  key: 0,
  class: "bi bi-check2 text-primary fs-1"
}
const _hoisted_54 = {
  key: 1,
  class: "bi bi-x-lg text-danger"
}
const _hoisted_55 = { class: "text-gray-600 fs-8" }
const _hoisted_56 = { class: "d-flex gap-3" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "dialog-footer" }
const _hoisted_66 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_67 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_MixedWidget16 = _resolveComponent("MixedWidget16")!
  const _component_MixedWidget17 = _resolveComponent("MixedWidget17")!
  const _component_MixedWidget18 = _resolveComponent("MixedWidget18")!
  const _component_MixedWidget14 = _resolveComponent("MixedWidget14")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ModalSelectPerson = _resolveComponent("ModalSelectPerson")!
  const _component_ModalRegister = _resolveComponent("ModalRegister")!
  const _component_ModalTest = _resolveComponent("ModalTest")!
  const _component_ModalTeamColor = _resolveComponent("ModalTeamColor")!
  const _component_ModalObservaciones = _resolveComponent("ModalObservaciones")!
  const _component_ModalItinerario = _resolveComponent("ModalItinerario")!
  const _component_ModalTeam = _resolveComponent("ModalTeam")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_DialogOrderDetail = _resolveComponent("DialogOrderDetail")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogNominal,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.dialogNominal) = $event)),
      fullscreen: true,
      class: "dialog-custom",
      onOpened: _ctx.onOpened,
      onClosed: _ctx.onClosed,
      "lock-scroll": "",
      "destroy-on-close": true
    }, {
      header: _withCtx(({}) => [
        _createVNode(_component_el_page_header, {
          icon: _ctx.ArrowLeft,
          onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogNominal = false))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_avatar, {
                size: 32,
                class: "me-3",
                src: _ctx.evento.logo
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.evento.name), 1),
                  (_ctx.sport?.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.sport.name), 1),
                        _hoisted_8,
                        _hoisted_9,
                        _createVNode(_component_el_tooltip, {
                          effect: "dark",
                          content: `Inscripciones ${_ctx.closure?.mstatus == 'O' ? 'habilitadas' : 'finalizadas'}`,
                          placement: "right"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.sport?.name)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(`bg-${_ctx.closure?.mstatus == 'O' ? 'success pulse-success' : 'danger pulse-danger'} rounded-circle border border-2 border-white h-20px w-20px`)
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.rowClub?.idinstitution)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.rowClub?.name) + "(" + _toDisplayString(_ctx.rowClub?.abrev) + ") ", 1),
                      _createVNode(_component_el_popover, {
                        width: 300,
                        placement: "right-start",
                        "popper-style": "box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
                      }, {
                        reference: _withCtx(() => [
                          _hoisted_11
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_el_avatar, {
                              size: 60,
                              src: `${_ctx.REPO}/${_ctx.repman.photo}`,
                              style: {"margin-bottom":"8px"}
                            }, null, 8, ["src"]),
                            _createElementVNode("div", null, [
                              _hoisted_13,
                              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.repman.person), 1)
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              (_ctx.repman.phone1)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                                    _hoisted_17,
                                    _createTextVNode("Celular: " + _toDisplayString(_ctx.repman.phone1), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.repman.email1)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                    _hoisted_19,
                                    _createTextVNode("Email: " + _toDisplayString(_ctx.repman.email1), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              (_ctx.closure?.dscount == 1)
                ? (_openBlock(), _createBlock(_component_CountDown, {
                    key: 0,
                    fechafin: _ctx.closure?.date_end,
                    "class-name": "text-center border rounded bg-success h6 fw-normal text-white",
                    "class-text": "mb-0 fw-bolder",
                    subtitle: "font-size:10px;",
                    dangerClass: "mb-4"
                  }, null, 8, ["fechafin"]))
                : _createCommentVNode("", true),
              _createVNode(_component_MixedWidget16, {
                title: "Participación total",
                "sub-title": "",
                class: "mb-3",
                amount: _ctx.total
              }, null, 8, ["amount"]),
              _createVNode(_component_MixedWidget17, {
                title: "Resumen por estado",
                "sub-title": "",
                class: "mb-3",
                "items-list": _ctx.listRCheckDoc
              }, null, 8, ["items-list"]),
              _createVNode(_component_MixedWidget18, {
                title: "Resumen por genero",
                "sub-title": "avance",
                class: "mb-3",
                "items-list": _ctx.listRGender
              }, null, 8, ["items-list"]),
              _createVNode(_component_MixedWidget14, {
                "widget-classes": "card-xxl-stretch mb-4 mb-xl-6",
                "widget-color": "#d9f5f8",
                loading: _ctx.loaderSumary,
                items: _ctx.listRTRegister
              }, null, 8, ["loading", "items"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            (_ctx.closure?.teams>0 && _ctx.listTeams.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_el_tabs, {
                    modelValue: _ctx.activeTab,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeTab) = $event)),
                    closable: _ctx.closure?.mstatus == 'O' ? true : false,
                    onTabRemove: _ctx.removeTab,
                    onTabClick: _ctx.onTabClick,
                    onTabChange: _ctx.tabChange,
                    type: "card",
                    class: "w-auto"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTeams, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tab_pane, {
                          class: "bg-success",
                          key: item.idteam,
                          label: item.alias,
                          name: item.idteam
                        }, null, 8, ["label", "name"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "closable", "onTabRemove", "onTabClick", "onTabChange"]),
                  _createVNode(_component_el_dropdown, {
                    "split-button": "",
                    type: "primary",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.operationTab(1))),
                    "popper-class": "fw-normal"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedTab && _ctx.operationTab(2)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('editTeam')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedTab && _ctx.removeTab(_ctx.selectedTab)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('deleteTeam')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_25,
                      _createTextVNode(_toDisplayString(_ctx.t('registerTeam')) + " ", 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.closure?.teams>0 && _ctx.listTeams.length == 0)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  description: "No se encontrarón equipos",
                  image: "/media/svg/illustrations/sigma/question.svg",
                  "image-size": 300
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "warning",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.operationTab(1)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Clic aquí para crear tu primer equipo")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["d-flex justify-content-between flex-wrap", _ctx.closure?.teams>0 && _ctx.listTeams.length > 0 ? 'p-3 border' : 'mb-3'])
                  }, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.tregister,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tregister) = $event)),
                      onChange: _ctx.getListNominal
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.tregister, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_radio_button, {
                            key: `erb-${index}`,
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    _createElementVNode("div", _hoisted_27, [
                      (_ctx.multipleSelection.length > 0 && (_ctx.username?.idperfil == 1 || _ctx.username?.idperfil == 7 || _ctx.username?.idperfil == 8))
                        ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
                            dropdown: _withCtx(() => [
                              _createVNode(_component_el_dropdown_menu, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_dropdown_item, { onClick: _ctx.activeCredential }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Activar Credenciales")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, { type: "primary" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Ejecutar "),
                                  _hoisted_28
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.username?.idperfil == 1 || _ctx.username?.idperfil == 7 || _ctx.username?.idperfil == 8)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            type: "warning",
                            onClick: _ctx.generarOrder,
                            class: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Generar orden")
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.closure?.mstatus == 'O')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.openModalSelectPersons,
                              class: "fw-normal"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_30,
                                _createTextVNode(_toDisplayString(_ctx.t('register')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_button, {
                              color: "#6D2077",
                              class: "fw-normal",
                              onClick: _ctx.sendDataValidation
                            }, {
                              default: _withCtx(() => [
                                _hoisted_31,
                                _createTextVNode(_toDisplayString(_ctx.t('finalizar')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_dropdown, null, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, {
                                command: "a",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'nominal', {
                                            a: _ctx.mbtoa(_ctx.evento.idevent),
                                            b: _ctx.mbtoa(_ctx.sport.idsport),
                                            c: _ctx.rowClub?.idinstitution ? _ctx.mbtoa(_ctx.rowClub?.idinstitution) : '',
                                            d: _ctx.listChecks
                                        })))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Ficha Nominal")
                                ]),
                                _: 1
                              }),
                              (_ctx.sport.categorie == 1)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 0,
                                    command: "a",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'auxiliar', {
                                            a: _ctx.mbtoa(_ctx.evento.idevent),
                                            b: _ctx.mbtoa(_ctx.sport.idsport),
                                            c: _ctx.rowClub?.idinstitution ? _ctx.mbtoa(_ctx.rowClub?.idinstitution) : '',
                                            d: _ctx.listChecks,
                                            e: _ctx.selectedTab
                                        })))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Ficha Auxiliar "),
                                      _createVNode(_component_el_tooltip, {
                                        class: "box-item",
                                        effect: "dark",
                                        content: "Descargar y presentar un dia antes del inicio de la competencia",
                                        placement: "right"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_34
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_dropdown_item, {
                                command: "a",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'remarks', {
                                            a: _ctx.mbtoa(_ctx.evento.idevent),
                                            b: _ctx.mbtoa(_ctx.sport.idsport),
                                            c: _ctx.rowClub?.idinstitution ? _ctx.mbtoa(_ctx.rowClub?.idinstitution) : '',
                                            d: _ctx.listChecks
                                        })))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Observaciones ")
                                ]),
                                _: 1
                              }),
                              (_ctx.username?.idperfil == 1 || _ctx.username?.idperfil == 2)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 1,
                                    command: "a",
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'checklist', {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: _ctx.rowClub?.idinstitution ? _ctx.mbtoa(_ctx.rowClub?.idinstitution) : '',
                                                d: _ctx.listChecks
                                            })))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" CheckList ")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.username?.idperfil == 1 || _ctx.username?.idperfil == 2)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 2,
                                    command: "a",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.DownloadXLSXPDF('xlsx', 'zebra-zc300', {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: _ctx.rowClub?.idinstitution ? _ctx.mbtoa(_ctx.rowClub?.idinstitution) : '',
                                                d: _ctx.listChecks
                                            })))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Zebra ZC300 ")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.callDownloadFile(
                                            'xlsx',
                                            'consolidated-participation',
                                            {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: _ctx.rowClub?.idinstitution ? _ctx.mbtoa(_ctx.rowClub?.idinstitution) : '',
                                                d: _ctx.listChecks
                                            }
                                        )))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Nominal General ")
                                ]),
                                _: 1
                              }),
                              (_ctx.sport?.fnc == 1)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 3,
                                    command: "a",
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.DownloadXLSXPDF('xlsx', `nominal/Competition`, {
                                            a: _ctx.mbtoa(_ctx.evento.idevent),
                                            b: _ctx.mbtoa(_ctx.sport.idsport),
                                            c: _ctx.rowClub?.idinstitution ? _ctx.mbtoa(_ctx.rowClub?.idinstitution) : '',
                                            d: _ctx.listChecks
                                        })))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Nominal de competencia ")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_dropdown_item, {
                                command: "a",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.DownloadXLSXPDF('xlsx', 'reporte-itinerario',
                                            { a: _ctx.evento.idevent, b: _ctx.sport.idsport })))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Reporte Itinerario ")
                                ]),
                                _: 1
                              }),
                              (_ctx.username?.idperfil == 1 || _ctx.username?.idperfil == 2)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 4,
                                    command: "a",
                                    onClick: _ctx.generateCredentials
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Credenciales "),
                                      _createVNode(_component_el_tooltip, {
                                        class: "box-item",
                                        effect: "dark",
                                        content: "Solo para registros aprobados",
                                        placement: "bottom"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_35
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            color: "#00c1ae",
                            class: "fw-normal text-white"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.loaderDownload)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_32))
                                : (_openBlock(), _createElementBlock("i", _hoisted_33)),
                              _createTextVNode(" " + _toDisplayString(_ctx.t('download')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ], 2),
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.searchText,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.searchText) = $event)),
                          placeholder: _ctx.t('search'),
                          "prefix-icon": _ctx.Search,
                          clearable: "",
                          class: "w-300px me-3"
                        }, null, 8, ["modelValue", "placeholder", "prefix-icon"])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.t('state')), 1),
                        _createVNode(_component_el_select, {
                          class: "w-200px",
                          modelValue: _ctx.listChecks,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.listChecks) = $event)),
                          onChange: _ctx.getListNominal,
                          multiple: "",
                          "collapse-tags": "",
                          "collapse-tags-tooltip": "",
                          placeholder: "Estado"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id,
                                disabled: _ctx.listChecks.length === 1 && _ctx.listChecks.includes(item.id)
                              }, null, 8, ["label", "value", "disabled"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ])
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    ref: "singleTableRef",
                    data: _ctx.filteredNominal,
                    "default-sort": { prop: 'gender', order: 'descending' },
                    onSelectionChange: _ctx.handleSelectionChange,
                    border: "",
                    style: {"width":"100%"},
                    "table-layout": "fixed",
                    height: `${_ctx.altura+30}px`,
                    "scrollbar-always-on": true,
                    "highlight-current-row": "",
                    class: "fs-7",
                    "header-cell-class-name": "text-black bg-light text-uppercase text-center",
                    "row-class-name": _ctx.tableRowClassName
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        type: "selection",
                        width: "50"
                      }),
                      _createVNode(_component_el_table_column, {
                        type: "index",
                        label: "N°",
                        width: "60",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "idacreditation",
                        label: "ID",
                        width: "80",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "docnumber",
                        label: _ctx.t('document').toUpperCase(),
                        width: "120"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("span", _hoisted_43, _toDisplayString(scope.row.doc_name), 1),
                            _hoisted_44,
                            _createElementVNode("span", _hoisted_45, _toDisplayString(scope.row.docnumber), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "persona",
                        label: _ctx.t('participant').toUpperCase(),
                        "min-width": "220"
                      }, {
                        default: _withCtx(({row, $index}) => [
                          _createElementVNode("div", {
                            class: "d-flex align-items-center text-hover-primary cursor-pointer gap-2",
                            onClick: ($event: any) => (_ctx.onEdit(row, 2, $index))
                          }, [
                            _createVNode(_component_el_avatar, {
                              "preview-teleported": "",
                              shape: "square",
                              size: 32,
                              fit: "contain",
                              src: `${_ctx.REPO}/${row.photo}`,
                              "preview-src-list": `${_ctx.REPO}/${row.photo}`,
                              class: _normalizeClass('border bg-white')
                            }, null, 8, ["src", "preview-src-list"]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("span", _hoisted_48, _toDisplayString(row.firstname.toLowerCase()), 1),
                              _hoisted_49,
                              _createElementVNode("span", _hoisted_50, _toDisplayString(row.lastname.toLowerCase() + ' ' + row.surname.toLowerCase()), 1)
                            ])
                          ], 8, _hoisted_46)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "birthday",
                        label: _ctx.t('birthday').toUpperCase(),
                        width: "140",
                        align: "center",
                        sortable: ""
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "gender",
                        label: _ctx.t('gender').toUpperCase(),
                        width: "90",
                        align: "center",
                        sortable: ""
                      }, {
                        default: _withCtx(({ row }) => [
                          (row.gender == 'M')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(row.gender), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(row.gender), 1))
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      (_ctx.tregister!='D')
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 0,
                            prop: "function_name",
                            label: _ctx.t('function').toUpperCase(),
                            width: "200"
                          }, null, 8, ["label"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_table_column, {
                        label: "CRED",
                        align: "center",
                        width: "70"
                      }, {
                        default: _withCtx(({ row }) => [
                          (row.credential == 1)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_53))
                            : (_openBlock(), _createElementBlock("i", _hoisted_54))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "created_at",
                        sortable: "",
                        label: _ctx.t('registered').toUpperCase(),
                        width: "150"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.moment(row?.created_at).format("DD/MM/YYYY hh:mm:ss")), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('state').toUpperCase(),
                        align: "center",
                        width: "110",
                        fixed: "right"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("span", {
                            class: _normalizeClass(`badge badge-${row.check_class}`)
                          }, _toDisplayString(row.check_name), 3)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: "OPCIÓN",
                        width: "160",
                        fixed: "right"
                      }, {
                        default: _withCtx(({ row, $index }) => [
                          _createElementVNode("div", _hoisted_56, [
                            (_ctx.closure?.itinerary == 1)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  effect: "dark",
                                  content: _ctx.t('itinerary'),
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["fa fa-plane fs-2 text-hover-danger cursor-pointer", `${(row.itinerario!=null && row.itinerario>0) ? 'text-success' : ''}`]),
                                      onClick: ($event: any) => (_ctx.openItinerario(row))
                                    }, null, 10, _hoisted_57)
                                  ]),
                                  _: 2
                                }, 1032, ["content"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_tooltip, {
                              effect: "dark",
                              content: _ctx.t('edit'),
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("i", {
                                  class: "bi bi-pencil-square fs-2 text-hover-primary cursor-pointer",
                                  onClick: ($event: any) => (_ctx.onEdit(row, 2, $index))
                                }, null, 8, _hoisted_58)
                              ]),
                              _: 2
                            }, 1032, ["content"]),
                            (_ctx.username?.idperfil == '1'|| row.checkdoc == 0)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 1,
                                  effect: "dark",
                                  content: _ctx.t('delete'),
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("i", {
                                      class: "bi bi-trash fs-2 text-hover-danger cursor-pointer",
                                      onClick: ($event: any) => (_ctx.onDelete(row))
                                    }, null, 8, _hoisted_59)
                                  ]),
                                  _: 2
                                }, 1032, ["content"]))
                              : _createCommentVNode("", true),
                            (row.checkdoc == 4)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 2,
                                  effect: "dark",
                                  content: "Ver observaciones",
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("i", {
                                      class: "bi bi-exclamation-triangle-fill fs-2 text-info cursor-pointer",
                                      onClick: ($event: any) => (_ctx.onObservations(row))
                                    }, null, 8, _hoisted_60)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (_ctx.closure?.verify_test == 1)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 3,
                                  effect: "dark",
                                  content: "Modificar Pruebas",
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("i", {
                                      class: "bi bi-bezier2 fs-2 text-hover-danger",
                                      onClick: ($event: any) => (_ctx.OnTest(row))
                                    }, null, 8, _hoisted_61)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_tooltip, {
                              effect: "dark",
                              content: "Agregar a orden",
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("i", {
                                  class: "bi bi-cart-plus fs-2 text-hover-info cursor-pointer",
                                  onClick: ($event: any) => (_ctx.addToOrder(row))
                                }, null, 8, _hoisted_62)
                              ]),
                              _: 2
                            }, 1024),
                            (row?.credential == '1')
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 4,
                                  effect: "dark",
                                  content: "Descargar credencial",
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("i", {
                                      onClick: ($event: any) => (_ctx.singleAcreditation(row)),
                                      class: "bi bi-person-vcard-fill fs-1 text-success text-hover-info cursor-pointer"
                                    }, null, 8, _hoisted_63)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data", "onSelectionChange", "height", "row-class-name"])), [
                    [_directive_loading, _ctx.loaderTable]
                  ])
                ]))
          ])
        ])), [
          [_directive_loading, _ctx.loaderGral]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onOpened", "onClosed"]),
    _createVNode(_component_ModalSelectPerson, {
      onGetSelectRow: _ctx.getSelectRow,
      "type-register": _ctx.tregister,
      sport: _ctx.sport,
      event: _ctx.evento,
      "row-club": _ctx.rowClub
    }, null, 8, ["onGetSelectRow", "type-register", "sport", "event", "row-club"]),
    _createVNode(_component_ModalRegister, {
      evento: _ctx.evento,
      sport: _ctx.sport,
      setting: _ctx.listSetting,
      onOnResponse: _ctx.onResponse,
      action: _ctx.action,
      "type-register": _ctx.tregister,
      "list-status": _ctx.listStatus
    }, null, 8, ["evento", "sport", "setting", "onOnResponse", "action", "type-register", "list-status"]),
    _createVNode(_component_ModalTest),
    _createVNode(_component_ModalTeamColor),
    _createVNode(_component_ModalObservaciones, { idacrd: _ctx.rowIdObs }, null, 8, ["idacrd"]),
    _createVNode(_component_ModalItinerario, {
      ref: "modalItinerarioRef",
      "row-selected": _ctx.rowSelected,
      onResItinerario: _ctx.resItinerario
    }, null, 8, ["row-selected", "onResItinerario"]),
    _createVNode(_component_ModalTeam, {
      ref: "dialogTeamRef",
      idregister: _ctx.selectedTab,
      action: _ctx.actionTab,
      idevent: _ctx.evento?.idevent,
      idsport: _ctx.sport?.idsport,
      "row-club": _ctx.rowClub,
      onTeamResponse: _ctx.teamResponse
    }, null, 8, ["idregister", "action", "idevent", "idsport", "row-club", "onTeamResponse"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogTerminos,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dialogTerminos) = $event)),
      title: "Declaración jurada",
      draggable: "",
      top: "0vh",
      onClosed: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isTerminos = false))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_65, [
          _createVNode(_component_el_button, {
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialogTerminos = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancelar")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: !_ctx.isTerminos,
            onClick: _ctx.sendVerification
          }, {
            default: _withCtx(() => [
              _createTextVNode("Enviar inscripción")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, {
          height: _ctx.altura <= 500 ? '500px' : _ctx.altura + 'px'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "px-8 h-100",
              innerHTML: _ctx.evento.tennor,
              width: "100%"
            }, null, 8, _hoisted_64)
          ]),
          _: 1
        }, 8, ["height"]),
        _createVNode(_component_el_checkbox, {
          class: "mt-4",
          modelValue: _ctx.isTerminos,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.isTerminos) = $event)),
          label: "Declaro que he leído y comprendido la presente declaración jurada en su totalidad.",
          size: "large"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_DialogOrderDetail, {
      ref: "DialogOrderDetailRef",
      "other-data": _ctx.otherData,
      "item-order": null,
      "items-details": _ctx.listSelectedOrder,
      onDeleteItemOrderDetail: _ctx.deleteItemOrderDetail,
      onOnResponseOrderDetails: _ctx.onResponseOrderDetails
    }, null, 8, ["other-data", "items-details", "onDeleteItemOrderDetail", "onOnResponseOrderDetails"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogCredentials,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dialogCredentials) = $event)),
      title: "Credenciales",
      width: "350",
      draggable: "",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_67, [
          _createVNode(_component_el_button, {
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.dialogCredentials = false)),
            disabled: _ctx.loadingCredential
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancelar")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.sendActiveCredentials
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.loadingCredential ? 'Guardando' : 'Guardar'), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("label", null, _toDisplayString(`${_ctx.optionCredential ? 'Habilitar' : 'Deshabilitar'} ${_ctx.multipleSelection.length} credenciales`), 1),
          _createVNode(_component_el_form_item, { class: "m-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.optionCredential,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.optionCredential) = $event)),
                style: {"--el-switch-on-color":"#13ce66","--el-switch-off-color":"#ff4949"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}